import React, { PureComponent } from 'react';
import styles from './index.css';
/**
 * 视频底部Tips组件
 */
class Tips extends PureComponent {
    render() {
        const { content } = this.props;
        return React.createElement("div", { className: styles.tips }, content);
    }
}
export default Tips;
